import React, { CSSProperties, forwardRef, SyntheticEvent } from 'react';
import styled from 'styled-components';
import colors from '../../constants/colors.constants';

export interface TextAreaProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string, event: SyntheticEvent) => void;
  style?: CSSProperties;
}
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => {
    const { style, value, placeholder, onChange } = props;

    return (
      <StyledTextArea
        $activeColor={colors.primary3}
        $borderDefaultColor={colors.border1}
        style={style}
        value={value}
        placeholder={placeholder}
        ref={ref}
        onChange={(e) => {
          const { target } = e;
          const { value } = target;
          if (onChange) {
            onChange(value, e);
          }
        }}
      />
    );
  },
);

export default TextArea;

const StyledTextArea = styled.textarea<{
  $borderDefaultColor: string;
  $activeColor: string;
}>`
  min-height: 160px;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 300;
  border-radius: 12px;

  border: ${(props) => {
    return `1px solid ${props.$borderDefaultColor}`;
  }};

  &:focus {
    outline: none;
    border: ${(props) => {
      return `1px solid ${props.$activeColor}`;
    }};
  }

  &:hover {
    border: ${(props) => {
      return `1px solid ${props.$activeColor}`;
    }};
  }

  transition: border 0.2s;
`;
